module.exports = __webpack_public_path__ + "static/table_english_3-0c3622bf824e459f9e1a9a3e12c255f7.png";